import { useEffect, useRef, useState } from "react";
import { useLocalStorage } from "../../../../hooks/localStorage/useLocalStorage";
import { PageSizeOptions } from "./PageSizeSelector";

const DefaultPageSize = PageSizeOptions[1];

export function useTransactionPagination(groupListItems?: number) {
  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  // groupListItems can flash to undefined (while transaction are-reloading)
  // so we create a stable reference here.
  const totalItemsRef = useRef<number>(groupListItems ?? 0);
  if (groupListItems !== undefined) {
    totalItemsRef.current = groupListItems;
  }

  const totalItems = totalItemsRef.current;

  const [savedPageSize, setSavedPageSize] = useLocalStorage(
    "pageSize",
    DefaultPageSize,
  );

  const pageSize =
    savedPageSize && PageSizeOptions.includes(savedPageSize) ?
      savedPageSize
    : DefaultPageSize;

  // savedPageSize comes from local storage, so we check here to ensure it's
  // valid
  useEffect(() => {
    if (savedPageSize && !PageSizeOptions.includes(savedPageSize)) {
      setSavedPageSize(DefaultPageSize);
    }
  }, [savedPageSize, setSavedPageSize]);

  useEffect(() => {
    const maxPageIndex = Math.max(0, Math.ceil(totalItems / pageSize) - 1);

    setCurrentPageIndex((oldPageIndex) => Math.min(oldPageIndex, maxPageIndex));
  }, [totalItems, pageSize]);

  return {
    totalItems,
    pageSize,
    setPageSize: setSavedPageSize,
    currentPageIndex,
    setCurrentPageIndex,
  };
}
